import http from "@/utils/http";


export const WechatOauthApi = {

    render(params) {
        return http.get(`/weixin/oauth/render`,params)
    },
    check(params) {
        return http.get(`/weixin/oauth/check`,params)
    },
    login(data) {
        return http.post(`/weixin/oauth/login`,data)
    },
    binding(data) {
        return http.post(`/weixin/oauth/binding`,data)
    },
}